import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/design/components/cr-delete-button.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { ChromiumSnackbar } from '@chancenwerk/client/design/components/cr-snackbar.js';
import { Workshop } from '@chancenwerk/shared/workshops/entities/Workshop.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../akademie-component-workshop-edit.js';

@customElement('akademie-dialog-workshop-edit')
export class AkademieDialogWorkshopEdit extends ChromiumDialog<Workshop> {
  static override get element_name() {
    return 'akademie-dialog-workshop-edit';
  }

  override heading?: string | undefined = 'Workshop bearbeiten';

  @property({ attribute: false }) workshop = new RXController(this, new Workshop({}));

  override content() {
    return html`<akademie-component-workshop-edit
      ${css({ minWidth: '600px' })}
      .workshop=${this.workshop.value}
      @saved=${(e: ValueEvent<Workshop>) => this._saved(e)}
      @error=${(e: any) => ChromiumSnackbar.show(e.detail.message as string)}
    ></akademie-component-workshop-edit>`;
  }

  private async _saved(e: ValueEvent<Workshop>) {
    await this.close(e.detail.value);
  }
}
